import axios from "axios";
import DefaultGetConfig from "../../../utils/defaultGetConfig";

const loadMotovehiculoData = async (authObj) => {
    let requestMarcas = process.env.REACT_APP_BACK_SERVER + '/getMarcasMotos'

    try {
        const response = await axios.get(requestMarcas, DefaultGetConfig(authObj));
        return {marcas: response.data};
    } catch (error) {
        console.error('Error loading automotor data:', error);
        throw error;
    }
};

export default loadMotovehiculoData;
